var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{class:[
    'gift-certificates-banner',
    _vm.customClass,
    {
      'gift-certificates-banner_mobile': _setup.isMobile
    }
    ]},[_c('div',{class:[
          'container',
          _vm.customClassContainer,
          {
            'container_mobile': _setup.isMobile,
            'container_discount': _setup.shouldShowDiscountBanner,
            [`${_vm.customClassContainer}_mobile`]: _setup.isMobileContainer,
            [`${_vm.customClassContainer}_mobile-discount`]: _setup.shouldShowMobileDiscountWithContainer,
          }
          ],on:{"click":_setup.openLinkCertificates}},[(_setup.isMobile)?_c('div',{class:[
        'gift-certificates-banner__img_mobile',
        {
          'gift-certificates-banner__img_mobile-discount': _setup.shouldShowMobileDiscountWithContainer,
        }
        ]}):_vm._e(),_vm._v(" "),_c('div',{class:[
        'gift-certificates-banner__content',
        {
          [`${_vm.customClassContainer}__content_mobile`]: _setup.isMobileContainer,
          [`${_vm.customClassContainer}__content_mobile-discount`]: _setup.shouldShowMobileDiscountWithContainer,
        }
        ]},[_c('div',{class:[
        'gift-certificates-banner__text',
        {
          'gift-certificates-banner__text_mobile': _setup.isMobile
        }
        ]},[_c('div',{class:[
              'gift-certificates-banner__title',
              {
                'gift-certificates-banner__title_mobile': _setup.isMobile
              }
              ]},[_vm._v("\n          "+_vm._s(_vm.title)+"\n          "),_c('br'),_vm._v("\n          "+_vm._s(_vm.titleWrapping)+"\n        ")]),_vm._v(" "),_c('div',{class:[
          'gift-certificates-banner__subtitle',
          _vm.customClass,
          {
            'gift-certificates-banner__subtitle_mobile': _setup.isMobile
          }
          ]},[_vm._v("\n          "+_vm._s(_vm.subtitle)+"\n        ")])]),_vm._v(" "),_c('div',{class:[
            'gift-certificates-banner__btn',
            {
              'gift-certificates-banner__btn_mobile': _setup.isMobile
            }
            ]},[_vm._v("\n        "+_vm._s(_vm.buttonText)+"\n      ")])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }